import OpenReplay from '@openreplay/tracker';

import { isProduction } from '../../helpers';

const recordingPercentage = 5;

window.NapkinOR = {
  isReady: false,

  init: function () {
    try {
      // Skip localhost sessions
      if (!isProduction()) {
        console.log('Skipping OpenReplay on non-production environment.');
        return;
      }

      // Only record a percentage of sessions
      const recording = window.sessionStorage.getItem('openReplayRecording');
      if (recording !== 'true' && Math.random() * 100 > recordingPercentage) {
        console.log('Skipping OpenReplay on this session.');
        return;
      }

      window.sessionStorage.setItem('openReplayRecording', 'true');

      this.tracker = new OpenReplay({
        projectKey: isProduction() ? '6gXsNDIBi9r8lbQoBvTa' : 'SubvuTXD3KLj1e6nPrtp',
        ingestPoint: 'https://openreplay.napkin.ai/ingest',
        disableSprites: true,
        capturePerformance: true,
        consoleThrottling: 50,
        defaultInputMode: 0,
        obscureTextNumbers: false,
        obscureTextEmails: false,
        obscureInputEmails: false,
        defaultInputMode: 0,
        __DISABLE_SECURE_MODE: isProduction() !== true,
      });

      this.tracker.start().then(() => {
        this.isReady = true;

        console.log('[OpenReplay] Started', this.tracker.getSessionURL());

        if (window.NapkinSentry) {
          var Sentry = window.NapkinSentry.getClient();
          if (Sentry) {
            Sentry.setTag('openReplaySessionID', this.tracker.getSessionID());
            Sentry.setTag('openReplaySessionToken', this.tracker.getSessionToken());
          }
        }
      });

      console.debug('[OpenReplay] Loaded');
    } catch (e) {
      console.error('[OpenReplay] Error in init: ', e);
    }
  },

  getClient: function () {
    return this.tracker;
  },
};

function loadOpenReplay() {
  window.NapkinOR.init();
}

export default loadOpenReplay;
